import { MEDIA_LG } from 'const'
import styled from 'styled-components'

// Colors
const COLOR_GRAY15 = 'rgb(240, 240, 240)'
const COLOR_GRAY1 = 'rgba(108, 117, 125, 1)'
const COLOR_BLACK2 = 'rgba(0, 0, 0, 0.95)'
const COLOR_GREEN2 = 'rgba(22, 189, 24, 1)'
const COLOR_RED2 = 'rgb(237, 28, 36)'
const DESIGN_WHITE = '#fff'

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const TableHeader = styled.div<{ $width: number }>`
  display: grid;
  grid-template-columns: ${({ $width }) => {
    if ($width > MEDIA_LG) return '20% 48% 20% 8%'
    return '26% 32% 17% 20%'
  }};
  gap: 4px;
  background-color: ${COLOR_GRAY15};
  color: ${COLOR_GRAY1};
  border: 0;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 1;
  font-weight: 600;
  white-space: nowrap;
  padding: 5px;
  table-layout: fixed;
`

export const TableRow = styled.div<{ $width: number }>`
  display: grid;
  grid-template-columns: ${({ $width }) => {
    if ($width > MEDIA_LG) return '20% 48% 20% 8%'
    return '26% 32% 17% 20%'
  }};
  gap: 4px;
  //background-color: ${DESIGN_WHITE};
  border: 0;
  color: ${COLOR_BLACK2};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  flex-wrap: nowrap;
  padding: 0 5px;
  table-layout: fixed;

  &:hover {
    background-color: ${COLOR_GRAY15};
  }
`

export const TableCell = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const TeamAvatar = styled.img`
  max-height: 20px;
`

export const At = styled.span`
  font-size: 14px;
  font-weight: 600;
`

export const OpponentCell = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
`

export const OpponentCellMultiTeam = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
  padding-left: 16px;
`

export const OpponentCellAt = styled.div`
  width: 16px;
`

export const OpponentName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
`

interface GameScoreStatusProps {
  $isWin?: boolean
  $isLose?: boolean
}

export const GameScoreStatus = styled.span<GameScoreStatusProps>`
  font-weight: 600;
  color: ${(props) => {
    if (props.$isWin) return COLOR_GREEN2
    if (props.$isLose) return COLOR_RED2
    return 'inherit'
  }};
`

export const CameraIcon = styled.svg`
  height: 18px;
  color: ${COLOR_RED2};
`

export const NFHSButton = styled.div<{ $width: number }>`
  display: flex;
  align-items: center;
  padding: 4px 5px 3px 5px;
  text-align: center;
  border: 1px solid transparent;
  background: linear-gradient(135deg, #ed1c24 0%, #b71d21 100%);
  border-radius: 0.75rem;

  svg {
    height: ${({ $width }) => ($width > MEDIA_LG ? '14px' : '10px')};
  }
`
